import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function DiscordMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 20 14" fill={color} style={style}><path d="M16.942 1.172A17.559 17.559 0 0012.816 0c-.195.322-.372.653-.529.992a16.623 16.623 0 00-4.579 0C7.551.653 7.374.322 7.179 0 5.754.225 4.365.62 3.05 1.175.44 4.744-.269 8.223.085 11.654A17.203 17.203 0 005.145 14c.41-.509.773-1.049 1.084-1.614a11.169 11.169 0 01-1.706-.753c.143-.096.283-.194.418-.29A12.716 12.716 0 0010 12.386c1.749 0 3.476-.356 5.059-1.043.137.103.277.202.418.29-.545.297-1.117.55-1.71.754.312.565.674 1.105 1.084 1.613a17.124 17.124 0 005.064-2.345c.415-3.978-.71-7.426-2.973-10.483zM6.678 9.544c-.987 0-1.802-.827-1.802-1.844 0-1.017.787-1.85 1.798-1.85A1.81 1.81 0 018.477 7.7c-.017 1.017-.794 1.844-1.8 1.844zm6.644 0c-.988 0-1.8-.827-1.8-1.844 0-1.017.787-1.85 1.8-1.85s1.816.833 1.798 1.85c-.017 1.017-.792 1.844-1.798 1.844z"  /></Svg>;
}
export default DiscordMedium;